import React, { MouseEventHandler } from 'react';
import { InfoButton } from '../connectedForm/Button';
import { useDispatch } from 'react-redux';
import { openFormActionInNewTab } from '../../utils/CheckPopUpBlockerFunction';
import { AlertType } from '../../graphql/schema/p4types';
import { BaseButton } from '@fluentui/react';
import Notification from './Notification';

export type ILinkNotificationProps = {
  title: string;
  linkTitle: string;

  /**
   * Must be provided, or it will default to "Unknown"
   */
  message: string;
  link?: string;
  type: AlertType;
  onClick?: MouseEventHandler<HTMLAnchorElement | HTMLButtonElement | HTMLDivElement | BaseButton | HTMLSpanElement>;
  onClose: () => void;
};

const LinkNotification = ({
  title,
  linkTitle = 'View Results',
  message,
  link,
  onClose,
  type,
  onClick,
}: ILinkNotificationProps) => {
  const dispatch = useDispatch();

  return (
    <Notification
      type={type}
      title={title}
      message={message}
      actionButtons={[
        <InfoButton
          key={'Results option'}
          onClick={
            onClick ||
            (() => {
              openFormActionInNewTab(dispatch, link);
              onClose();
            })
          }
        >
          {linkTitle}
        </InfoButton>,
      ]}
    />
  );
};

export default LinkNotification;
